// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"260":"8ee47810","453":"b45f8309","470":"9c8eb628","725":"040271c1","831":"7259cb85"}[chunkId] + ".chunk.js";
};